module.exports = __webpack_public_path__ + "img/icon_user.3ba5b90e.png";